import qs from "qs";

import store from "@/store";

console.log("=======================================");
console.log(store);
console.log("=======================================");

export const useRequest = data => {
  data.headers["X-API-KEY"] = 123456;
  data.oldUrl = data.url;
  if (store && store.state && store.state.user) {
    data.headers["x-uid"] = store.state.user.id;
  }
  console.log("useRequest", data);

  if (/^\/venue/.test(data.url)) {
    data.url = "/web/venue";
  }

  if (/^\/exhibitPage/.test(data.url)) {
    const params = data.url.split("?");
    if (params[1]) {
      const { page, size } = qs.parse(params[1]);
      data.params = {
        page: +page || 0,
        size
      };
    }
    data.url = "/web/exhibitPage";
  }

  if (/^\/exhibitorPage/.test(data.url)) {
    const params = data.url.split("?");
    if (params[1]) {
      const { page, size } = qs.parse(params[1]);
      data.params = {
        page: +page || 0,
        size
      };
    }
    data.url = "/web/exhibitorPage";
  }

  if (/^\/exhibitsPage/.test(data.url)) {
    const params = data.url.split("?");
    if (params[1]) {
      const { page, size } = qs.parse(params[1]);
      data.params = {
        page: +page || 0,
        size
      };
    }
    data.url = "/web/exhibitPage";
  }

  if (/^\/articles/.test(data.url)) {
    const params = data.url.split("?");
    if (params[1]) {
      const { page, size } = qs.parse(params[1]);
      data.params = {
        page: +page || 0,
        size
      };
    }
    data.url = "/web/articlePage";
  }

  if (/^\/article-category/.test(data.url)) {
    data.params = {
      type: "EXHIBIT_CATEGORY"
    };
    data.url = "/web/category";
  }

  if (/^\/advertisement/.test(data.url)) {
    data.url = "/web/getAdvertisement";
    const putLocationId = data.params["category.id"];
    const path = data.params["path"];
    data.params = {};
    if (path) {
      data.params["path"] = path;
      data.params["linkType"] = "EXHIBIT";
    }
    if (putLocationId) {
      data.params["putLocationId"] = putLocationId;
      if ([2, 3].includes(putLocationId)) {
        data.url = "/web/getExhibitAdvertisements";
        if (putLocationId == 2) {
          data.params["linkType"] = "EXHIBIT";
        }
        if (putLocationId == 3) {
          data.params["linkType"] = "EXHIBITOR";
        }
      }
    }
  }

  if (/^\/exhibits/.test(data.url)) {
    const params = data.url.split("?");
    if (params[1]) {
      const { page, size } = qs.parse(params[1]);
      data.params = {
        page: +page || 0,
        size,
        ...data.params
      };
    }
    data.url = "/web/getHotExhibits";
  }

  if (/^\/exhibit-category/.test(data.url)) {
    data.params = {
      type: "EXHIBIT_CATEGORY",
      size: data.params.size
    };
    data.url = "/web/category";
  }

  return data;
};



// WEBPACK FOOTER //
// ./src/api-map/request.js